import { useNavigate, Link } from "react-router-dom";
import { FiMenu, FiLogOut } from "react-icons/fi";
import { MdOutlineAttachFile } from "react-icons/md";
import { ImFilesEmpty } from "react-icons/im";
import { LiaMoneyCheckAltSolid } from "react-icons/lia";
import "./Sidebar.css";

export default function Sidebar({ collapsed, setCollapsed }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  return (
    <div className={`sidebar ${collapsed ? "collapsed" : ""}`}>
      <div className="top-section">
        <div className="toggle-btn" onClick={() => setCollapsed(!collapsed)}>
          <FiMenu />
        </div>

        <nav className="nav-links">
          <Link to="/analise" className="nav-link">
            <MdOutlineAttachFile className="icon" />
            {!collapsed && <span>Análise Jurídica e Financeira</span>}
          </Link>

          <Link to="/precatorios" className="nav-link">
            <ImFilesEmpty className="icon" />
            {!collapsed && <span>Lista de Precatórios</span>}
          </Link>
        </nav>
      </div>

      <div className="logout-section" onClick={handleLogout}>
        <FiLogOut className="icon" />
        {!collapsed && <span>Sair</span>}
      </div>
    </div>
  );
}
